import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../Layout/PageLayout";
import { currentApkVersion as initialApk } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./UpdateApkPage.css";

const UpdateApkPage = () => {
  const [apkInfo, setApkInfo] = useState(initialApk);
  const [selectedFile, setSelectedFile] = useState(null);
  const [newVersion, setNewVersion] = useState("");
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (!file.name.toLowerCase().endsWith(".apk")) {
        alert("Please select an APK file.");
        return;
      }
      setSelectedFile(file);
      setUploadSuccess(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer?.files?.[0];
    if (file && file.name.toLowerCase().endsWith(".apk")) {
      setSelectedFile(file);
      setUploadSuccess(false);
    } else if (file) {
      alert("Please drop an APK file.");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => setDragOver(false);

  const handleUpload = (e) => {
    e.preventDefault();
    if (!selectedFile) {
      alert("Please select an APK file to upload.");
      return;
    }
    const version = newVersion.trim() || selectedFile.name.replace(/\.apk$/i, "").replace(/[^0-9.]/g, "") || "1.0.0";
    setApkInfo({
      version,
      uploadedAt: new Date().toISOString().slice(0, 10),
      forceUpdate: apkInfo.forceUpdate,
    });
    setSelectedFile(null);
    setNewVersion("");
    setUploadSuccess(true);
  };

  const formatDate = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
    } catch {
      return iso || "—";
    }
  };

  return (
    <PageLayout
      title="Update Apk"
      breadcrumb={
        <Link to="/dashboard/homepage" className="dashboard-hero__breadcrumb">
          Dashboard
        </Link>
      }
    >
      <div className="update-apk-grid">
        <div className="update-apk-card update-apk-card--version">
          <h2 className="update-apk-card__title">Current APK Version</h2>
          <div className="update-apk-version-row">
            <span className="update-apk-version-label">Version</span>
            <span className="update-apk-version-value">{apkInfo.version}</span>
          </div>
          <div className="update-apk-version-row">
            <span className="update-apk-version-label">Uploaded on</span>
            <span className="update-apk-version-value">{formatDate(apkInfo.uploadedAt)}</span>
          </div>
          {apkInfo.forceUpdate && (
            <div className="update-apk-badge update-apk-badge--force">Force update enabled</div>
          )}
        </div>

        <div className="update-apk-card update-apk-card--upload">
          <h2 className="update-apk-card__title">Upload New APK</h2>
          <form onSubmit={handleUpload} className="update-apk-form">
            <div
              className={`update-apk-dropzone ${dragOver ? "update-apk-dropzone--active" : ""}`}
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
            >
              <input
                type="file"
                accept=".apk"
                onChange={handleFileChange}
                className="update-apk-file-input"
                id="apk-file"
              />
              <label htmlFor="apk-file" className="update-apk-dropzone-label">
                {selectedFile ? (
                  <span className="update-apk-filename">{selectedFile.name}</span>
                ) : (
                  <>
                    <span className="update-apk-dropzone-icon">📦</span>
                    <span>Drop APK here or click to browse</span>
                  </>
                )}
              </label>
            </div>
            <div className="update-apk-field">
              <label htmlFor="apk-version" className="update-apk-field-label">
                Version (e.g. 2.1.1)
              </label>
              <input
                id="apk-version"
                type="text"
                placeholder="2.1.1"
                value={newVersion}
                onChange={(e) => setNewVersion(e.target.value)}
                className="update-apk-input"
              />
            </div>
            <button type="submit" className="update-apk-submit">
              Upload APK
            </button>
            {uploadSuccess && (
              <p className="update-apk-success">APK uploaded successfully. Current version has been updated.</p>
            )}
          </form>
        </div>
      </div>
    </PageLayout>
  );
};

export default UpdateApkPage;
